import { render, staticRenderFns } from "./MoleculeServiceDetail.vue?vue&type=template&id=4b2035e1&scoped=true&"
import script from "./MoleculeServiceDetail.vue?vue&type=script&lang=js&"
export * from "./MoleculeServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeServiceDetail.vue?vue&type=style&index=0&id=4b2035e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2035e1",
  null
  
)

export default component.exports